export default "__VITE_ASSET__6c49f7f2__"